const state = {
    allUsers: null,
    allowedUsers: null,
    notAllowedUsers: [],
    pendingUsers: [],
    removeUserAccessDialogOpen: false,
    grantUserAccessDialogOpen: false,
};
export default state;
